var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"mainbord"},[(_vm.fullImageUrl != '' && _vm.fullImageUrl != null)?_c('img',{attrs:{"src":_vm.fullImageUrl}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }